<template>
  <div class="material-container">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <div class="nav-tab" @click="showCategoryDropdown = !showCategoryDropdown">
        <div>
          <img
            src="@/assets/image/fl1.png"
            alt="材料分类"
            class="tab-icon"
          >
          <span>材料分类</span>
        </div>
        <img
          src="@/assets/image/xia1.png"
          alt="下箭头"
          class="arrow-icon"
          :class="{ 'arrow-up': showCategoryDropdown }"
        >
      </div>
      <div class="nav-tab" @click="goToSupplierList">
        <div>
          <img
            src="@/assets/image/gys1.png"
            alt="供应商列表"
            class="tab-icon"
          >
          <span>供应商列表</span>
        </div>
        <img
          src="@/assets/image/you.png"
          alt="右箭头"
          class="arrow-icon"
        >
      </div>
    </div>

    <!-- 材料分类下拉框 -->
    <div v-if="showCategoryDropdown" class="category-dropdown">
      <div class="dropdown-content">
        <!-- 左侧分类导航 -->
        <div class="category-sidebar">
          <div
            v-for="(category, index) in materialCategories"
            :key="index"
            class="category-item"
            :class="{ active: selectedCategoryIndex === index }"
            @click="selectCategory(index)"
          >
            <img
              :src="getCategoryIcon(index)"
              :alt="category.name"
              class="category-icon"
            >
            <span>{{ category.name }}</span>
          </div>
        </div>

        <!-- 右侧子分类内容 -->
        <div class="subcategory-content">
          <div class="subcategory-grid">
            <div
              v-for="(subcategory, subIndex) in currentSubcategories"
              :key="subIndex"
              class="subcategory-item"
              :class="{ active: selectedSubcategoryIndex === subIndex }"
              @click="selectSubcategory(subIndex)"
            >
              {{ subcategory }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="search-input">
        <img
          src="@/assets/image/search1.png"
          alt="搜索"
          class="search-icon"
        >
        <input
          type="text"
          placeholder="请输入材料名称、规格型号或品牌搜索"
        >
      </div>
      <button class="search-btn">搜索</button>
    </div>

    <!-- 筛选控制栏 -->
    <div class="filter-bar">
      <div class="filter-left">
        <el-dropdown @command="handleDateChange">
          <span class="filter-item">
            {{ currentDate }}
            <i class="el-icon-arrow-down" />
          </span>
          <el-dropdown-menu slot="dropdown" class="date-dropdown-menu">
            <!-- 年份选择器 -->
            <div class="year-selector">
              <img class="year-nav" src="@/assets/image/zuo.png" alt="" @click="changeYear(-1)">
              <span class="year-item" :class="{ active: selectedYear === year - 1 }" @click="selectYear(year - 1)">{{ year - 1 }}</span>
              <span class="year-item active" @click="selectYear(year)">{{ year }}</span>
              <span class="year-item" :class="{ active: selectedYear === year + 1 }" @click="selectYear(year + 1)">{{ year + 1 }}</span>
              <img class="year-nav" src="@/assets/image/you.png" alt="" @click="changeYear(1)">
            </div>

            <!-- 月份列表 -->
            <div class="month-list">
              <div
                v-for="month in monthOptions"
                :key="month.value"
                class="month-item"
                :class="{ active: currentDate === month.label }"
                @click="handleDateChange(month.value)"
              >
                {{ month.label }}
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCategoryChange">
          <span class="filter-item">
            {{ currentCategory }}
            <i class="el-icon-arrow-down" />
          </span>
          <el-dropdown-menu slot="dropdown" class="category-dropdown-menu">
            <el-dropdown-item
              v-for="category in categoryOptions"
              :key="category.value"
              :command="category.value"
              :class="{ active: currentCategory === category.label }"
            >
              {{ category.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="filter-right">
        <a
          href="#"
          class="info-link"
        >
          <img
            src="@/assets/image/wenhao1.png"
            alt="说明"
            class="info-icon"
          >
          本期说明
        </a>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧分类栏 -->
      <div class="sidebar">
        <div class="category-item active">
          <span>全部价格信息</span>
        </div>
        <div class="category-item">
          <span>门窗</span>
        </div>
        <div class="category-item">
          <span>钢构件</span>
        </div>
        <div class="category-item">
          <span>装饰块料</span>
        </div>
        <div class="category-item">
          <span>黑色及有色金属</span>
        </div>
        <div class="category-item">
          <span>水泥及混凝土制品</span>
        </div>
        <div class="category-item">
          <span>砖、瓦、灰、砂石</span>
        </div>
        <div class="category-item">
          <span>保温、绝缘材料</span>
        </div>
        <div class="category-item">
          <span>涂料及防水材料</span>
        </div>
        <div class="category-item">
          <span>油漆及化工材料</span>
        </div>
        <div class="category-item">
          <span>钢筋混凝土管</span>
        </div>
        <div class="category-item">
          <span>预拌混凝土</span>
        </div>
        <div class="category-item">
          <span>预拌砂浆</span>
        </div>
        <div class="category-item">
          <span>吊顶、隔墙及屋面板</span>
        </div>
      </div>

      <!-- 右侧数据表格 -->
      <div class="content-area">
        <div class="table-container">
          <table class="material-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>材料名称</th>
                <th>规格型号</th>
                <th>单位</th>
                <th>除税价</th>
                <th>含税价</th>
                <th>历史价</th>
                <th>税率</th>
                <th>专业</th>
                <th>备注</th>
                <th>收藏</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in tableData"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.spec }}</td>
                <td>{{ item.unit }}</td>
                <td>
                  <a
                    href="#"
                    class="price-link"
                  >查看价格</a>
                </td>
                <td>
                  <a
                    href="#"
                    class="price-link"
                  >查看价格</a>
                </td>
                <td>
                  <img src="@/assets/image/shang.png" alt="">
                  <!-- <img src="@/assets/image/xia.png" alt=""> -->
                </td>
                <td>
                  <i class="el-icon-arrow-right" />
                </td>
                <td>{{ item.profession }}</td>
                <td>{{ item.remark }}</td>
                <td>
                  <img
                    src="@/assets/image/scn.png"
                    alt="收藏"
                    class="collect-icon"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Material',
  data() {
    return {
      // 控制下拉框显示
      showCategoryDropdown: false,
      // 当前选中的分类索引
      selectedCategoryIndex: 0,
      // 当前选中的子分类索引
      selectedSubcategoryIndex: 0,
      // 当前选中的专业分类
      currentCategory: '房建',
      // 专业分类选项
      categoryOptions: [
        { label: '房建', value: 'building' },
        { label: '公路', value: 'highway' },
        { label: '国家电网', value: 'state_grid' },
        { label: '京标价协', value: 'beijing_standard' },
        { label: '京津冀综合管廊', value: 'integrated_tunnel' }
      ],
      // 当前选中的日期
      currentDate: '北京市2024年12月京津冀综合...',
      // 当前年份
      year: 2024,
      // 选中的年份
      selectedYear: 2024,
      // 月份选项
      monthOptions: [
        { label: '北京市2024年12月京津冀综合...', value: '2024-12' },
        { label: '北京市2024年11月京津冀综合...', value: '2024-11' },
        { label: '北京市2024年10月京津冀综合...', value: '2024-10' },
        { label: '北京市2024年09月京津冀综合...', value: '2024-09' },
        { label: '北京市2024年08月京津冀综合...', value: '2024-08' },
        { label: '北京市2024年07月京津冀综合...', value: '2024-07' },
        { label: '北京市2024年06月京津冀综合...', value: '2024-06' },
        { label: '北京市2024年05月京津冀综合...', value: '2024-05' },
        { label: '北京市2024年04月京津冀综合...', value: '2024-04' },
        { label: '北京市2024年03月京津冀综合...', value: '2024-03' },
        { label: '北京市2024年02月京津冀综合...', value: '2024-02' },
        { label: '北京市2024年01月京津冀综合...', value: '2024-01' }
      ],
      // 材料分类数据
      materialCategories: [
        {
          name: '装配式建筑',
          subcategories: [
            '混凝土预制品', '混凝土构件', '水泥砂浆', '灰浆/水泥浆', '钢筋', '钢板', '其他配套材料',
            '钢构件', '钢结构制品', '钢板', '圆钢', '型钢', '镀锌钢管', '铝板材', '型材', '装饰板', '硅酸钙板',
            '墙板、屋面板', '其他配套材料',
            '仿木构件', '仿木构件制品',
            '部品、部件', '成品墙板/屋面板', '成品风管/风道', '成品风帽', '成品栏杆/栏板', '成品装饰线条',
            '成品木门窗', '成品餐柜', '成品台/柜', '成品洗脸/洗手盆', '其他配套材料'
          ]
        },
        {
          name: '土建',
          subcategories: [
            '基础材料', '结构材料', '砌体材料', '防水材料', '保温材料', '装饰材料', '其他土建材料'
          ]
        },
        {
          name: '电气',
          subcategories: [
            '电缆电线', '开关插座', '灯具照明', '配电设备', '电气配件', '其他电气材料'
          ]
        },
        {
          name: '装饰',
          subcategories: [
            '墙面装饰', '地面装饰', '天花装饰', '门窗装饰', '家具装饰', '其他装饰材料'
          ]
        },
        {
          name: '暖通',
          subcategories: [
            '空调设备', '通风设备', '供暖设备', '管道材料', '阀门配件', '其他暖通材料'
          ]
        },
        {
          name: '市政',
          subcategories: [
            '道路材料', '桥梁材料', '排水材料', '照明设备', '交通设施', '其他市政材料'
          ]
        },
        {
          name: '给排水',
          subcategories: [
            '给水管道', '排水管道', '阀门配件', '水泵设备', '水处理设备', '其他给排水材料'
          ]
        },
        {
          name: '消防工程',
          subcategories: [
            '消防设备', '消防管道', '消防配件', '报警设备', '灭火器材', '其他消防材料'
          ]
        },
        {
          name: '园林绿化',
          subcategories: [
            '植物材料', '园林设施', '灌溉设备', '景观材料', '园林工具', '其他园林材料'
          ]
        },
        {
          name: '仿古工程',
          subcategories: [
            '仿古建材', '仿古装饰', '仿古配件', '传统工艺', '仿古设备', '其他仿古材料'
          ]
        }
      ],
      tableData: [
        { name: '埃比胡子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '房建', remark: '此材料价格为造价处发布' },
        { name: '埃比胡颓子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '京津冀综...', remark: '此材料价格为造价处发布' },
        { name: '以比胡子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '房建', remark: '此材料价格为造价处发布' },
        { name: '埃比胡子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '京津冀综...', remark: '此材料价格为造价处发布' },
        { name: '埃比胡颓子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '房建', remark: '此材料价格为造价处发布' },
        { name: '以比胡子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '京津冀综...', remark: '此材料价格为造价处发布' },
        { name: '埃比胡子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '房建', remark: '此材料价格为造价处发布' },
        { name: '埃比胡颓子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '京津冀综...', remark: '此材料价格为造价处发布' },
        { name: '以比胡子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '房建', remark: '此材料价格为造价处发布' },
        { name: '埃比胡子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '京津冀综...', remark: '此材料价格为造价处发布' },
        { name: '埃比胡颓子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '房建', remark: '此材料价格为造价处发布' },
        { name: '以比胡子', spec: '50*40美植装高度 80-100cm冠幅90-100cm', unit: '盆', profession: '京津冀综...', remark: '此材料价格为造价处发布' }
      ]
    }
  },
  computed: {
    // 当前分类的子分类列表
    currentSubcategories() {
      return this.materialCategories[this.selectedCategoryIndex]?.subcategories || []
    }
  },
  methods: {
    // 获取分类图标
    getCategoryIcon(index) {
      const iconNumber = index + 1
      return require(`@/assets/image/cl/${iconNumber}.png`)
    },
    // 选择分类
    selectCategory(index) {
      this.selectedCategoryIndex = index
      this.selectedSubcategoryIndex = 0 // 重置子分类选择
    },
    // 选择子分类
    selectSubcategory(index) {
      this.selectedSubcategoryIndex = index
      // 这里可以添加根据子分类筛选数据的逻辑
      console.log('选择了子分类:', this.currentSubcategories[index])
    },
    // 处理专业分类变更
    handleCategoryChange(categoryValue) {
      const selectedCategory = this.categoryOptions.find(opt => opt.value === categoryValue)
      if (selectedCategory) {
        this.currentCategory = selectedCategory.label
        // 这里可以添加根据专业分类筛选数据的逻辑
        console.log('选择了专业分类:', selectedCategory.label)
        this.$message.success(`已切换到${selectedCategory.label}`)
      }
    },
    // 处理日期变更
    handleDateChange(dateValue) {
      const selectedMonth = this.monthOptions.find(opt => opt.value === dateValue)
      if (selectedMonth) {
        this.currentDate = selectedMonth.label
        // 这里可以添加根据日期筛选数据的逻辑
        console.log('选择了日期:', selectedMonth.label)
        this.$message.success(`已切换到${selectedMonth.label}`)
      }
    },
    // 选择年份
    selectYear(year) {
      this.selectedYear = year
      this.year = year
      this.updateMonthOptions()
    },
    // 切换年份
    changeYear(direction) {
      this.year += direction
      this.updateMonthOptions()
    },
    // 更新月份选项
    updateMonthOptions() {
      const months = ['12', '11', '10', '09', '08', '07', '06', '05', '04', '03', '02', '01']
      this.monthOptions = months.map(month => ({
        label: `北京市${this.year}年${month}月京津冀综合...`,
        value: `${this.year}-${month}`
      }))
    },
    // 跳转到供应商列表页面
    goToSupplierList() {
      this.$router.push('/material/supplierList')
    }
  }
}
</script>

<style lang="scss" scoped>
.material-container {
  width: var(--page-container-ratio, 70%);
  margin: 0 auto;
  padding: 20px;
  position: relative; /* 为下拉框提供定位参考 */
}

/* 顶部导航栏 */
.top-nav {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.nav-tab {
  width: 46%;
  height: 80px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 30px;
  background: #fff;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
	display: flex;
	align-items: center;
	justify-content: space-between;

	div{
		display: flex;
		align-items: center;
	}
  .tab-icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
    object-fit: contain;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }

  .arrow-icon {
    width: 23px;
    height: 16px;
    transition: transform 0.3s ease;

    &.arrow-up {
      transform: rotate(180deg);
    }
  }

  &:nth-child(2) .tab-icon {
    width: 24px;
    height: 24px;
  }

  &:nth-child(2) .arrow-icon {
    width: 14px;
    height: 16px;
  }
}

/* 材料分类下拉框 */
.category-dropdown {
  position: absolute;
  top: 120px; /* 定位在顶部导航栏下方 */
  left: 20px; /* 与容器左边距对齐 */
  right: 20px; /* 与容器右边距对齐 */
  z-index: 1000;
}

.dropdown-content {
  display: flex;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  min-height: 400px;
}

.category-sidebar {
  width: 200px;
  background: #f8f9fa;
  border-right: 1px solid #e9ecef;
}

.category-sidebar .category-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #e9ecef;

  &:hover {
    background: #e9ecef;
  }

  &.active {
    background: #0f6fe2;
    color: #fff;

    .category-icon {
      filter: brightness(0) invert(1);
    }
  }

  .category-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    transition: filter 0.3s ease;
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }
}

.subcategory-content {
  flex: 1;
  padding: 20px;
  background: #fff;
}

.subcategory-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.subcategory-item {
  padding: 8px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  color: #333;
  white-space: nowrap;

  &:hover {
    background: #e9ecef;
    border-color: #0f6fe2;
  }

  &.active {
    background: #0f6fe2;
    color: #fff;
    border-color: #0f6fe2;
  }
}

/* 搜索区域 */
.search-section {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  gap: 0;
}

.search-input {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #f39800;
  border-radius: 10px;
  padding: 0 15px;
  width: 100%;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  .search-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  input {
    border: none;
    outline: none;
    height: 60px;
    width: 100%;
    font-size: 14px;

    &::placeholder {
      color: #999;
    }
  }
}

.search-btn {
  background: #f39800;
  color: #fff;
  border: none;
  width: 160px;
  height: 62px;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  &:hover {
    background: #e08a00;
  }
}

/* 筛选控制栏 */
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #f8f9fa;
  border-radius: 6px;
}

.filter-left {
  display: flex;
  gap: 20px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 15px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}

.info-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0f6fe2;
  text-decoration: none;
  font-size: 14px;

  .info-icon {
    width: 16px;
    height: 16px;
  }
}

// 专业分类下拉菜单样式
::v-deep .category-dropdown-menu {
  min-width: 200px !important;
  padding: 0 !important;
  border-radius: 6px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;

  .el-dropdown-menu__item {
    padding: 12px 20px !important;
    font-size: 14px !important;
    color: #333 !important;
    transition: all 0.3s ease !important;
    border-bottom: 1px solid #f0f0f0 !important;

    &:last-child {
      border-bottom: none !important;
    }

    &:hover {
      background: #f8f9fa !important;
      color: #0f6fe2 !important;
    }

    &.active {
      background: #0f6fe2 !important;
      color: #fff !important;
    }
  }
}

// 日期下拉菜单样式
::v-deep .date-dropdown-menu {
  min-width: 300px !important;
  padding: 0 !important;
  border-radius: 6px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;

  .el-dropdown-menu__item {
    padding: 0 !important;
    line-height: normal !important;
  }
}

.year-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e9ecef;

  .year-nav {
    cursor: pointer;
   width: 8px;
    transition: all 0.3s ease;

    &:hover {
      background: #e9ecef;
      color: #0f6fe2;
    }
  }

  .year-item {
    cursor: pointer;
    font-size: 14px;
    color: #999;
    padding: 5px 10px;
    border-radius: 4px;
    transition: all 0.3s ease;

    &:hover {
      background: #e9ecef;
      color: #0f6fe2;
    }

    &.active {
      font-weight: bold;
      color: #333;
      background: #fff;
    }
  }
}

.month-list {
  max-height: 300px;
  overflow-y: auto;
  background: #fff;

  .month-item {
    padding: 12px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.3s ease;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f8f9fa;
      color: #0f6fe2;
    }

    &.active {
      background: #0f6fe2;
      color: #fff;
    }
  }
}

/* 主要内容区域 */
.main-content {
  display: flex;
  gap: 20px;
}

.sidebar {
  width: 250px;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 20px 0;
}

.category-item {
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;

  &:hover {
    background: #e9ecef;
  }

  &.active {
    background: #0f6fe2;
    color: #fff;
  }

  span {
    font-size: 14px;
  }
}

.content-area {
  flex: 1;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}

.table-container {
  overflow-x: auto;
}

.material-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px 8px;
    text-align: center;
    border-bottom: 1px solid #eee;
    font-size: 13px;
  }

  th {
    background: #f8f9fa;
    font-weight: 600;
    color: #333;
  }

  td {
    color: #666;
  }

  .price-link {
    color: #0f6fe2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .trend-icon {
    color: #52c41a;
    font-size: 16px;
  }

  .collect-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

/* 响应式设计 */
@media (max-width: 1600px) {
  .material-container {
    width: 92%;
    padding: 12px;
  }

  .nav-tab {
    height: 64px;
    padding: 0 16px;
  }

  .dropdown-content {
    min-height: 320px;
  }
}

@media (max-width: 1366px) {
  .material-container {
    width: 96%;
    padding: 8px;
  }

  .nav-tab {
    height: 56px;
    padding: 0 12px;
  }

  .category-sidebar {
    width: 168px;
  }
}

@media (max-width: 1200px) {
  .material-container {
    width: 95%;
  }

  .search-input {
    width: 300px;
  }

  .sidebar {
    width: 200px;
  }

  .dropdown-content {
    min-height: 350px;
  }

  .category-sidebar {
    width: 180px;
  }
}

@media (max-width: 768px) {
  .material-container {
    width: 100%;
    padding: 10px;
  }

  .top-nav {
    flex-direction: column;
    gap: 15px;
  }

  .search-section {
    width: 100%;
  }

  .search-input {
    width: 100%;
  }

  .main-content {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
  }

  .dropdown-content {
    flex-direction: column;
    min-height: auto;
  }

  .category-sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e9ecef;
  }

  .category-sidebar .category-item {
    padding: 12px 15px;
  }

  .subcategory-content {
    padding: 15px;
  }

  .subcategory-grid {
    gap: 8px;
  }

  .subcategory-item {
    padding: 6px 12px;
    font-size: 13px;
  }
}
</style>
